import { clientEnv } from "./env";

/**
 * A minified client stack trace with no source map is useless, and an SPA has
 * no server log to fall back on. Loaded lazily so builds without a DSN pay nothing.
 */
export async function initMonitoring() {
  if (!clientEnv.VITE_SENTRY_DSN) return;
  const Sentry = await import("@sentry/react");
  Sentry.init({
    dsn: clientEnv.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_RELEASE,
    tracesSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}
